<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="os-tabs-w" v-if="current.id">
              <div class="os-tabs-controls os-tabs-complex text-right">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <span aria-expanded="true" class="nav-link active">
                      <span class="tab-label">Barra #</span>
                      <span class="tab-value">{{ current.barra }}</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="element-box mb-0">
              <router-link
                class="btn"
                :to="{ name: 'wms-contenedor', params: {} }"
              >
                <a
                  class="btn btn-sm btn-link font-weight-bold"
                  style="font-size: 15px"
                  >&nbsp;
                  <u><i class="fas fa-angle-double-left"></i> Regresar</u>
                  &nbsp;</a
                >
              </router-link>
              <div class="st-meta float-right">
                <button @click="refreshCurrent()" class="btn btn-info">
                  Actualizar Info. <i class="fas fa-sync"></i>
                </button>
                &nbsp;
                <div class="btn-group">
                  <button
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn btn-success dropdown-toggle"
                    data-toggle="dropdown"
                    type="button"
                    :disabled="current.estado_str == 'Dado de baja'"
                  >
                    <i class="fa fa-cogs"></i>
                    Acciones
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button
                      class="dropdown-item"
                      v-if="current.fecha_fin_carga == null"
                      :disabled="current.estado_str == 'Dado de baja'"
                      href="#"
                      @click="finalizarCarga()"
                    >
                      <i class="fas fa-check-circle"></i> Finalizar Carga
                    </button>
                    <button
                      class="dropdown-item"
                      :disabled="current.detalle && current.detalle[0]"
                      href="#"
                      @click="anularTransaccion()"
                    >
                      <i class="fas fa-ban"></i> Dar de baja contenedor
                    </button>
                    <button
                      class="dropdown-item"
                      :disabled="current.fecha_fin_carga != null"
                      href="#"
                      @click="modificarContenedor()"
                    >
                      <i class="fa fa-file"></i> Modificar datos del contendor
                    </button>
                    <button
                      class="dropdown-item"
                      :disabled="current.fecha_fin_carga == null"
                      href="#"
                      @click="imprimir(current)"
                    >
                      <i class="fa fa-file"></i> Imprimir reporte general
                    </button>
                    <button
                      class="dropdown-item"
                      :disabled="current.fecha_fin_carga == null"
                      href="#"
                      @click="imprimirDetalle(current)"
                    >
                      <i class="fa fa-file"></i> Imprimir detalle de tarimas
                    </button>
                    <button
                      class="dropdown-item"
                      :disabled="current.fecha_fin_carga == null"
                      href="#"
                      v-if="
                        current.estado_str == 'En destino' &&
                        current.fecha_retorno == null
                      "
                      @click="retornoContenedor()"
                    >
                      <i class="fa fa-check"></i> Finalizar Carga y Retornar
                    </button>
                  </div>
                </div>
              </div>
              <h5 v-if="!current.pk" class="form-header">
                Contenedor
                <span v-if="current.numero != null"
                  ># {{ current.numero }}</span
                >
                &nbsp;
                <span
                  v-if="current.estado_str != 'Dado de baja'"
                  class="badge badge-success"
                  ><i class="fas fa-truck"></i> &nbsp;
                  {{ current.estado_str }}</span
                >
                <span
                  v-if="current.estado_str == 'Dado de baja'"
                  class="badge badge-danger"
                  ><i class="fas fa-truck"></i> &nbsp;
                  {{ current.estado_str }}</span
                >
              </h5>
              <small
                v-if="current.errors && current.errors.detail"
                class="form-text text-danger"
                >{{ current.errors.detail }}</small
              >
              <div class="row">
                <div class="col-md-6">
                  <TiendaSelectComponent
                    titulo="Tienda Origen"
                    :disabled="true"
                    :current="current"
                  />
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.tienda &&
                          current.errors.tienda.length > 0,
                      }"
                      >Tienda Destino</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      required
                      :disabled="true"
                      v-model="current.tienda_destino"
                      @input="$emit('input', $event.target.value)"
                    >
                      <option
                        v-for="(tienda, key) in tiendas"
                        :value="tienda.codigo"
                        :key="key"
                      >
                        {{ tienda.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.tienda"
                      class="form-text text-danger"
                      >{{ current.errors.tienda[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-md-4 col-md-4">
                  <div class="form-group">
                    <UsuariosSelectComponent
                      titulo="Encargado"
                      :current="current"
                      :disabled="current.estado != 'A'"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Matricula</label>
                    <input
                      v-model="current.matricula"
                      autofocus="autofocus"
                      class="form-control"
                      placeholder="Matricula"
                      type="text"
                      :disabled="true"
                    />
                    <small
                      v-if="current.errors && current.errors.matricula"
                      class="form-text text-danger"
                      >{{ current.errors.matricula[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Piloto</label>
                    <input
                      v-model="current.piloto"
                      autofocus="autofocus"
                      class="form-control"
                      placeholder="Matricula"
                      type="text"
                      :disabled="true"
                    />
                    <small
                      v-if="current.errors && current.errors.matricula"
                      class="form-text text-danger"
                      >{{ current.errors.matricula[0] }}</small
                    >
                  </div>
                </div>
              </div>
              <div class="form-buttons-w">
                <button v-if="false" class="btn btn-primary" @click="guardar()">
                  Guardar
                </button>
              </div>
              <NuevaTarimaModalComponent
                :current="current"
                titleButton="Agregar Tarima Devolución"
                v-if="
                  current.estado_str == 'En destino' &&
                  current.fecha_retorno == null
                "
                @refresh="refreshCurrent"
              />
              <NuevaTarimaModalComponent
                :current="current"
                v-if="current.fecha_fin_carga == null"
                @refresh="refreshCurrent"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="current.id != null">
          <TarimaTableComponent
            @click="rowClick"
            :current="current"
            @refresh="refreshCurrent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContenedorService from "@/services/wms/ContenedorService";
import CommonService from "@/services/commons/CommonService";
import Notifications from "@/notifications/notifications";
import NuevaTarimaModalComponent from "@/components/wms/contenedor/NuevaTarimaModalComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import TarimaTableComponent from "@/components/wms/contenedor/TarimaTableComponent";
import { mapGetters } from "vuex";
import Api from "@/services/Api";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TiendaSelectComponent,
    UsuariosSelectComponent,
    NuevaTarimaModalComponent,
    TarimaTableComponent,
  },
  data() {
    return {
      current: {
        estado: "9",
        errors: {},
      },
    };
  },

  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      this.refreshData();
    }
  },
  methods: {
    modificarContenedor() {
      $("#modificarInformacionContenedor").modal("show");
    },
    refreshData() {
      let self = this;
      ContenedorService.getById(this.$route.params.id).then((response) => {
        this.current = response.data;
        this.current.usuario = response.data.encargado_obj;
        this.current.tienda = response.data.tienda_origen;
        this.current.errors = [];
      });
    },
    anularTransaccion() {
      let self = this;
      Notifications.alert.confirm(
        "Dar de baja contenedor",
        "¿Esta seguro(a)?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "contenedor",
            self.current.id,
            "dar_de_baja"
          )
            .then((response) => {
              Notifications.toast.success(
                "dar de baja contenedor",
                "Realizado exitosamente"
              );
              self.refreshData();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Dar de baja contenedor",
                error.response.data.detail
              );
            });
        }
      );
    },
    rowClick() {
      let self = this;
      $("#opciones").modal("show");
    },
    retornoContenedor() {
      let self = this;
      Notifications.alert.confirm(
        "¿Esta seguro(a)?",
        "No puede regresar a un estado anterior",
        "",
        function () {
          DynamicService.postActionList("wms", "contenedor", "retorno", {
            barra: self.current.barra,
          })
            .then((res) => {
              self.refreshCurrent();
            })
            .catch((err) => {
              console.log(err.response.data);
              if (err.response.data.detail) {
                self.error_msg = err.response.data.detail;
              }
            });
        }
      );
    },
    refreshCurrent() {
      let self = this;
      ContenedorService.getById(self.current.id).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.encargado_obj;
        self.current.tienda = response.data.tienda_origen;
        self.current.errors = [];
        self.current.estado = "A";
      });
    },
    imprimirDetalle(current) {
      let self = this;
      self.id = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/contenedor/contenedor_detalle.jrxml&id=${self.id}`
      );
    },
    imprimir(current) {
      let self = this;
      self.id = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/contenedor/contenedor.jrxml&id=${self.id}`
      );
    },
    guardar() {
      let self = this;
      var current = Object.assign({}, self.current);
      if (current.id == null) {
        delete current.id;
      }
      if (self.current.usuario) {
        current.encargado = self.current.usuario.id;
      }
      ContenedorService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Contenedor",
            "Se ha Modificado la Información."
          );
          self.refreshCurrent();
        })
        .catch((error) => {
          if (error.response) {
            self.current.errors = error.response.data;
          }
        });
    },
    finalizarCarga() {
      let self = this;
      Notifications.alert.confirm(
        "Finalizar la carga de el contenedor",
        "¿Esta Seguro?",
        "",
        function () {
          ContenedorService.finalizar(self.current.id)
            .then((res) => {
              self.refreshCurrent();
              Notifications.toast.success(
                "Finalizar carga de contenedor",
                "Realizado correctamente."
              );
            })
            .catch((error) => {
              self.current.errors = Object.assign({}, error.response.data);
              if ("detail" in error.response.data) {
                Notifications.alert.error("Error", error.response.data.detail);
              }
            });
        }
      );
    },
    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "tarima",
        "¿Esta seguro de eliminar la tarima del contenedor",
        "Si Eliminar",
        function () {
          ContenedorService.remover_tarima_a_contenedor(self.current.id, {
            tarima_barra: detalle.barra,
          })
            .then((response) => {
              Notifications.toast.success(
                "tarima",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Vue.nextTick(function () {
                if ("detail" in error.response.data) {
                  Notifications.alert.error(
                    "Error",
                    error.response.data.detail
                  );
                }
              });
            });
        }
      );
    },
  },
};
</script>
